<template>
  <el-collapse :value="['1', '2']">
    <el-collapse-item title="设置展开项" name="1">
      选择需要展开的二级导航
      <div class="menu-choose-container">
        <el-radio-group v-model="currentSetMenu" @input="selectSubmenu">
          <el-radio
            :label="menu.publicId"
            v-for="menu in selectOptions"
            :disabled="!menu.children || !menu.children.length"
            :key="menu.publicId"
            style="width: 100%"
            >{{ menu.label }}</el-radio
          >
        </el-radio-group>
      </div>
    </el-collapse-item>
    <el-collapse-item title="选择样式" name="2" class="padding_0">
      <subStyles
        :productStyles="subMenuTypes"
        :selectId.sync="currentMenuStyleType"
        @select="selectSubMenuType"
      ></subStyles>
    </el-collapse-item>
    <menu-config
      :key="4"
      v-if="currentMenuStyleType == 4"
      :configs="subMenuThreeProps"
      :config-data="currentSubMenuConfig"
      :menu-configs="subMenuThreeConfigs"
      :options="options"
    />
    <menu-config
      :key="2"
      v-else-if="currentMenuStyleType == 2"
      :configs="subMenuOneProps"
      :config-data="currentSubMenuConfig"
      :menu-configs="subMenuOneConfigs"
      :options="options"
    />
    <propMap
      v-else-if="currentMenuStyleType !== 1"
      :configs="
        currentMenuStyleType == 2 ? MenuOneConfigs : currentMenuStyleType == 3 ? MenuTwoConfigs : MenuThreeConfigs
      "
      :configData.sync="currentSubMenuConfig"
      :options="options"
      :key="currentSetMenu + currentSetStyle"
    ></propMap>

    <!-- <el-collapse-item name="1" title="详细设置" v-if="currentSetStyle != 1"  class="padding_0"> 
      <propMap :configs="currentMenuStyleType == 2 ? MenuOneConfigs : []" :configData.sync="currentSubMenuConfig" :key="currentSetMenu"></propMap>
    </el-collapse-item> -->
  </el-collapse>
</template>
<script>
import { props } from "../menuThree/props.js"
import menuSettings from "../menuThree/menuSetting.js"
import menuOneSettings from "../menuOne/menuSetting.js"
import MenuOneConfigs from "../menuOne/props.js"
import MenuTwoConfigs from "../menuTwo/props.js"
import MenuThreeConfigs from "../menuThree/props.js"
import subStyles from "./subStyles.vue"
import propMap from "./propMap.vue"
import { produce } from "immer"
import menuConfig from "../setting/menu-config.vue"
export default {
  components: {
    propMap,
    subStyles,
    menuConfig
  },
  props: {
    currentSetStyle: undefined,
    rectId: undefined,
    selectOptions: Array,
    options: Object,
    subMenuConfig: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    subMenuIndex() {
      return this.subMenuConfig.findIndex(item => item.menuId === this.currentSetMenu)
    },
    currentSubMenuConfig: {
      get() {
        const self = this
        const originConfig = this.subMenuConfig.find(item => item.menuId === this.currentSetMenu)?.extraConfig
        const configForSet = Object.create(null)
        const proxyConfig = new Proxy(
          {},
          {
            get(target, key) {
              return originConfig[key]
            },
            set(target, key, newVal) {
              const newState = produce(self.subMenuConfig, draft => {
                draft[self.subMenuIndex]?.extraConfig && (draft[self.subMenuIndex].extraConfig[key] = newVal)
              })
              self.$emit("update:subMenuConfig", newState)
              return true
            }
          }
        )
        return proxyConfig
      },
      set(newValue) {
        const index = this.subMenuConfig.findIndex(item => item.menuId === this.currentSetMenu)
        index && this.subMenuConfig.splice(index, 1, { ...this.subMenuConfig[index], extraConfig: newValue })
        this.$emit("update:subMenuConfig", JSON.parse(JSON.stringify(this.subMenuConfig)))
      }
    },
    currentMenuStyleType: {
      get() {
        return this.subMenuConfig.find(item => item.menuId === this.currentSetMenu)?.styleId || 1
      },
      set(styleId) {
        this.$emit("update:currentSetStyle", styleId)
      }
    }
  },
  data() {
    return {
      MenuOneConfigs,
      MenuTwoConfigs,
      MenuThreeConfigs,
      subMenuTypes: [
        {
          id: 1,
          name: "样式一",
          cover: require("./images/style1.png")
        },
        {
          id: 2,
          name: "样式二",
          cover: require("./images/style2.png")
        },
        {
          id: 3,
          name: "样式三",
          cover: require("./images/style3.png")
        },
        {
          id: 4,
          name: "样式四",
          cover: require("./images/style4.png")
        }
      ],
      currentSetMenu: undefined
    }
  },
  created() {
    this.subMenuThreeProps = props
    this.subMenuOneProps = MenuOneConfigs
    this.subMenuThreeConfigs = menuSettings
    this.subMenuOneConfigs = menuOneSettings
  },
  mounted() {
    const defaultSetMenu = this.selectOptions.find(item => item?.children?.length)
    this.currentSetMenu = defaultSetMenu.publicId
    this.currentMenuStyleType = this.subMenuConfig.find(item => item.menuId === this.currentSetMenu)?.styleId || 1
  },
  methods: {
    selectSubmenu(menuId) {
      const menuConfig = this.subMenuConfig.find(item => item.menuId === menuId)
      if (menuConfig) {
        this.currentMenuStyleType = menuConfig.styleId
      } else {
        this.$emit("update:subMenuConfig", this.subMenuConfig.slice(0).concat([{ menuId, styleId: 1 }]))
        this.currentMenuStyleType = 1
      }
      this.$eventBus.$emit("openSelectedSubMenu", {
        rect_id: this.rectId,
        publicId: menuId
      })
    },
    selectSubMenuType(styleId) {
      const index = this.subMenuConfig.findIndex(item => item.menuId === this.currentSetMenu)
      // this.$emit('update:menuConfig', this.subMenuConfig.slice(0).concat([{menuId, styleId: 1}]))
      const newSubMenuConfig = produce(this.subMenuConfig, draft => {
        if (index === -1) {
          draft.push({ styleId, extraConfig: {}, menuId: this.currentSetMenu })
        } else {
          draft.splice(index, 1, {
            ...this.subMenuConfig[index],
            styleId,
            extraConfig: {},
            menuId: this.currentSetMenu
          })
        }
      })
      this.$emit("update:subMenuConfig", newSubMenuConfig)
      // const newSubMenuConfig = this.subMenuConfig.splice(index == -1 ? this.subMenuConfig.length - 1 : index, 1, {...this.subMenuConfig[index], styleId, extraConfig: {}, menuId: this.currentSetMenu})
      // this.subMenuConfig.splice(index == -1 ? this.subMenuConfig.length - 1 : index, 1, {...this.subMenuConfig[index], styleId, extraConfig: {}, menuId: this.currentSetMenu})
      // this.$emit('update:currentSetStyle', styleId)
      this.currentMenuStyleType = styleId
      this.$eventBus.$emit("openSelectedSubMenu", {
        rect_id: this.rectId,
        publicId: this.currentSetMenu
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-choose-container {
  border-radius: 4px;
  padding: 5px 12px;
  background-color: var(--cardBgColor);
  border: 1px solid var(--sliderBackGround);
}
</style>
